/* Sunglass Resort - collector (NFT) access.
   Client-side check: connects a wallet, asks Ethereum whether it holds the NFT
   (directly, or via a delegate.xyz delegation), then reveals NFT-locked items.
   NOTE: this is a convenience lock, not strong security. */
(function () {
  var CONFIG = {
    // Edit here: which NFT unlocks things
    // Add more collections here: { name, address }. Holding ANY of them unlocks access.
    collections: [
      { name: 'Bored Ape Yacht Club', address: '0xBC4CA0EdA7647A8aB7C2061c2E118A18a936f13D' },
      { name: 'Mutant Ape Yacht Club', address: '0x60E4d786628Fea6478F785A6d7e704777c86a7c6' }
    ],
    rpcs: ['https://ethereum-rpc.publicnode.com', 'https://cloudflare-eth.com', 'https://eth.llamarpc.com'],
    // Links shown after unlock. Add a line for each gated brand.
    unlockLinks: [
      { text: 'Chanel', url: '/collections/chanel' },
      { text: 'Chrome Hearts', url: '/collections/chrome-hearts' }
    ],
    navLabel: 'Chanel',
    hoursValid: 1
  };
  var DELEGATE_V2 = '0x00000000000000447e69651d841bD8D104Bed493';
  var DELEGATE_V1 = '0x00000000000076A84feF008CDAbe6409d2FE638B';
  var WARM = '0xC3AA9bc72Bd623168860a1e5c6a4530d3D80456c'; // warm.xyz
  var KEY = 'sr_nft_access';
  var root = document.documentElement;

  function pad(addr) { return addr.toLowerCase().replace('0x', '').padStart(64, '0'); }
  function isAddr(a) { return /^0x[0-9a-fA-F]{40}$/.test(a || ''); }

  function rpc(method, params) {
    var i = 0;
    function attempt() {
      if (i >= CONFIG.rpcs.length) return Promise.reject(new Error('Could not reach Ethereum'));
      var url = CONFIG.rpcs[i++];
      return fetch(url, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ jsonrpc: '2.0', id: 1, method: method, params: params })
      }).then(function (r) { return r.json(); }).then(function (j) {
        if (j.error) throw new Error(j.error.message);
        return j.result;
      }).catch(attempt);
    }
    return attempt();
  }
  function call(to, data) { return rpc('eth_call', [{ to: to, data: data }, 'latest']); }
  var CONTRACTS = CONFIG.collections.map(function (c) { return c.address; });
  function bal(contract, owner) {
    return call(contract, '0x70a08231' + pad(owner)).then(function (r) { return BigInt(r || '0x0') > 0n; });
  }
  // warm.xyz: balanceOf(nftContract, wallet) counts NFTs held by the wallet OR any cold wallet linked to it
  function warmBal(contract, wallet) {
    return call(WARM, '0xf7888aec' + pad(contract) + pad(wallet)).then(function (r) { return BigInt(r || '0x0') > 0n; });
  }
  function delegatedFor(contract, wallet, vault) {
    var zero32 = '0'.repeat(64);
    var v2 = '0x8988eea9' + pad(wallet) + pad(vault) + pad(contract) + zero32;
    var v1 = '0x90c9a2d0' + pad(wallet) + pad(vault) + pad(contract);
    return Promise.all([
      call(DELEGATE_V2, v2).then(function (r) { return BigInt(r || '0x0') > 0n; }).catch(function () { return false; }),
      call(DELEGATE_V1, v1).then(function (r) { return BigInt(r || '0x0') > 0n; }).catch(function () { return false; })
    ]).then(function (x) { return x[0] || x[1]; });
  }
  // true if fn(contract) is true for any collection
  function any(fn) {
    return Promise.all(CONTRACTS.map(function (c) { return fn(c).catch(function () { return false; }); }))
      .then(function (r) { return r.some(Boolean); });
  }
  function short(a) { return a ? a.slice(0, 6) + '\u2026' + a.slice(-4) : ''; }

  // returns {ok, lines[]}
  function verify(wallet, vault) {
    var lines = [];
    return any(function (c) { return bal(c, wallet); }).then(function (ok) {
      lines.push('Connected wallet ' + short(wallet) + ': ' + (ok ? 'holds a qualifying NFT' : 'holds none'));
      if (ok) return { ok: true, lines: lines };
      return any(function (c) { return warmBal(c, wallet); }).then(function (w) {
        lines.push('warm.xyz link from ' + short(wallet) + ': ' + (w ? 'qualifying NFT found' : 'none found'));
        if (w) return { ok: true, lines: lines };
        return checkVault(wallet, vault, lines);
      });
    });
  }
  function checkVault(wallet, vault, lines) {
    return Promise.resolve().then(function () {
      if (!vault) { lines.push('No delegate.xyz wallet address entered.'); return { ok: false, lines: lines }; }
      if (!isAddr(vault)) {
        lines.push('The delegate address you entered is not valid (' + vault.length + ' characters, it should be 42 starting with 0x).');
        return { ok: false, lines: lines };
      }
      return any(function (c) {
        return Promise.all([bal(c, vault), delegatedFor(c, wallet, vault)]).then(function (x) { return x[0] && x[1]; });
      }).then(function (ok) {
        lines.push('Delegate wallet ' + short(vault) + ' linked to ' + short(wallet) + ': ' + (ok ? 'found' : 'not found'));
        return { ok: ok, lines: lines };
      });
    });
  }

  function setOk(wallet) {
    root.classList.add('nft-ok');
    try { localStorage.setItem(KEY, JSON.stringify({ w: wallet, t: Date.now() })); } catch (e) {}
    render();
  }
  function clearOk() {
    root.classList.remove('nft-ok');
    try { localStorage.removeItem(KEY); } catch (e) {}
  }

  // restore a recent verification (re-checked on chain)
  function restore() {
    var saved = null;
    try { saved = JSON.parse(localStorage.getItem(KEY) || 'null'); } catch (e) {}
    if (!saved || !saved.w || Date.now() - saved.t > CONFIG.hoursValid * 3600 * 1000) { clearOk(); return; }
    root.classList.add('nft-ok');
    // Access verified on connect is trusted for the time window (no re-check on every page:
    // public Ethereum servers are rate-limited and a failed lookup must never lock a holder out).
  }

  // ---------- UI ----------
  var panel, btn, statusEl;
  var CSS = [
    '.srn-btn,.srn-panel,.srn-panel *{box-sizing:border-box;font-family:inherit;letter-spacing:normal;}',
    '.srn-btn{position:fixed;left:16px;bottom:16px;z-index:50;background:#fff;color:#111;border:1px solid #111;padding:9px 16px;font-size:11px;line-height:1;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;transition:background .15s,color .15s;}',
    '.srn-btn:hover{background:#111;color:#fff;}',
    '.srn-panel{position:fixed;left:16px;bottom:58px;z-index:51;width:320px;max-width:calc(100vw - 32px);background:#fff;color:#111;border:1px solid #111;padding:22px 22px 20px;box-shadow:0 12px 40px rgba(0,0,0,.18);display:none;}',
    '.srn-panel[hidden],.srn-panel [hidden]{display:none !important;}',
    '.srn-head{display:flex;justify-content:space-between;align-items:center;margin-bottom:14px;}',
    '.srn-title{font-size:11px;letter-spacing:.16em;text-transform:uppercase;font-weight:600;}',
    '.srn-x{background:none;border:0;font-size:20px;line-height:1;cursor:pointer;color:#111;padding:0 2px;}',
    '.srn-text{margin:0 0 18px;font-size:14px;line-height:1.5;color:#333;}',
    '.srn-primary{display:block;width:100%;padding:13px 12px;border:1px solid #111;background:#111;color:#fff;font-size:11px;line-height:1;letter-spacing:.14em;text-transform:uppercase;cursor:pointer;transition:background .15s,color .15s;}',
    '.srn-primary:hover{background:#fff;color:#111;}',
    '.srn-details{margin-top:14px;font-size:12px;color:#555;}',
    '.srn-details summary{cursor:pointer;list-style:none;text-decoration:underline;text-underline-offset:3px;}',
    '.srn-details summary::-webkit-details-marker{display:none;}',
    '.srn-details input{display:block;width:100%;margin-top:10px;padding:10px;border:1px solid #bbb;font-size:12px;background:#fff;color:#111;}',
    '.srn-links{display:block;margin:0 0 16px;}',
    '.srn-links a{display:flex;justify-content:space-between;align-items:center;padding:13px 0;border-top:1px solid #e3e3e3;color:#111;text-decoration:none;font-size:13px;letter-spacing:.1em;text-transform:uppercase;}',
    '.srn-links a:last-child{border-bottom:1px solid #e3e3e3;}',
    '.srn-links a:hover{opacity:.6;}',
    '.srn-link{background:none;border:0;padding:0;font-size:12px;color:#555;text-decoration:underline;text-underline-offset:3px;cursor:pointer;}',
    '.srn-status{margin-top:14px;font-size:12px;line-height:1.6;color:#555;}',
    '.srn-status:empty{display:none;}'
  ].join('');

  function toggle(show) {
    var open = typeof show === 'boolean' ? show : panel.style.display === 'none' || panel.style.display === '';
    panel.style.display = open ? 'block' : 'none';
  }

  function build() {
    var st = document.createElement('style');
    st.id = 'sr-nft-css';
    st.textContent = CSS;
    document.head.appendChild(st);

    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'srn-btn';
    btn.textContent = 'Collector access';

    panel = document.createElement('div');
    panel.className = 'srn-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', 'Collector access');
    panel.innerHTML =
      '<div class="srn-head"><span class="srn-title">Collector Access</span>' +
      '<button type="button" class="srn-x" data-close aria-label="Close">×</button></div>' +
      '<div data-locked>' +
        '<p class="srn-text">Hold collector access? Connect your wallet to unlock collector pieces.</p>' +
        '<button type="button" class="srn-primary" data-connect>Connect wallet</button>' +
        '<details class="srn-details"><summary>Using delegate.xyz?</summary>' +
        '<input data-vault placeholder="Address of the wallet that holds the NFT (0x\u2026)" autocomplete="off" spellcheck="false"></details>' +
      '</div>' +
      '<div data-unlocked hidden>' +
        '<p class="srn-text">Access unlocked.</p>' +
        '<div class="srn-links" data-links></div>' +
        '<button type="button" class="srn-link" data-disconnect>Disconnect</button>' +
      '</div>' +
      '<div class="srn-status" data-status></div>';

    document.body.appendChild(btn);
    document.body.appendChild(panel);
    statusEl = panel.querySelector('[data-status]');
    btn.addEventListener('click', function () { toggle(); });
    panel.querySelector('[data-close]').addEventListener('click', function () { toggle(false); });
    panel.querySelector('[data-connect]').addEventListener('click', connect);
    panel.querySelector('[data-disconnect]').addEventListener('click', disconnect);
    var note = document.querySelector('[data-nft-404]');
    if (note && !root.classList.contains('nft-ok')) toggle(true);
    render();
  }

  // Adds / removes a "Chanel" link in the top menu while access is active
  function navLink() {
    var ok = root.classList.contains('nft-ok');
    var old = document.querySelectorAll('[data-nft-nav]');
    if (!ok) { for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]); return; }
    if (old.length) return;
    var desk = document.querySelector('.header__inline-menu > ul.list-menu--inline');
    if (desk) {
      var li = document.createElement('li');
      li.setAttribute('data-nft-nav', '');
      li.innerHTML = '<a href="' + CONFIG.unlockLinks[0].url + '" class="header__menu-item list-menu__item link link--text focus-inset"><span>' + CONFIG.navLabel + '</span></a>';
      desk.appendChild(li);
    }
    var mob = document.querySelector('.menu-drawer__navigation > ul.menu-drawer__menu');
    if (mob) {
      var li2 = document.createElement('li');
      li2.setAttribute('data-nft-nav', '');
      li2.innerHTML = '<a href="' + CONFIG.unlockLinks[0].url + '" class="menu-drawer__menu-item list-menu__item link link--text focus-inset">' + CONFIG.navLabel + '</a>';
      mob.appendChild(li2);
    }
  }

  function tidy() {
    // (top-menu link removed: Chanel now lives in the Brands menu)
    if (!root.classList.contains('nft-ok')) return;
    var h1 = document.querySelector('[data-nft-real] h1');
    if (h1 && document.querySelector('[data-nft-404]') && !document.documentElement.getAttribute('data-nft-titled')) {
      document.documentElement.setAttribute('data-nft-titled', '1');
      var parts = document.title.split(/\s[\u2013-]\s/);
      var shop = parts.length > 1 ? parts[parts.length - 1] : '';
      document.title = h1.textContent.trim() + (shop ? ' \u2013 ' + shop : '');
    }
    var links = document.querySelectorAll('main a[href*="/account/login"]');
    for (var i = 0; i < links.length; i++) if (/have an account/i.test(links[i].textContent)) links[i].parentNode.style.display = 'none';
  }

  function render() {
    tidy();
    if (!statusEl) return;
    var ok = root.classList.contains('nft-ok');
    panel.querySelector('[data-locked]').hidden = ok;
    panel.querySelector('[data-unlocked]').hidden = !ok;
    btn.textContent = ok ? 'Collector access \u2713' : 'Collector access';
    if (ok) {
      panel.querySelector('[data-links]').innerHTML = CONFIG.unlockLinks.map(function (l) {
        return '<a href="' + l.url + '"><span>' + l.text + '</span><span aria-hidden="true">\u2192</span></a>';
      }).join('');
      statusEl.textContent = '';
    }
  }
  function disconnect() {
    clearOk();
    try { localStorage.removeItem(KEY + '_vault'); } catch (e) {}
    try {
      if (window.ethereum && window.ethereum.request) {
        window.ethereum.request({ method: 'wallet_revokePermissions', params: [{ eth_accounts: {} }] }).catch(function () {});
      }
    } catch (e) {}
    window.location.reload();
  }
  function say(msg) { if (statusEl) statusEl.textContent = msg; }

  function connect() {
    if (!window.ethereum) {
      say('No wallet found in this browser. On a phone, open this page inside your wallet app’s browser (MetaMask, Rainbow, Coinbase Wallet).');
      return;
    }
    say('Waiting for your wallet…');
    window.ethereum.request({ method: 'eth_requestAccounts' }).then(function (accts) {
      var wallet = accts && accts[0];
      var vaultInput = panel.querySelector('[data-vault]');
      var vault = vaultInput && vaultInput.value.replace(/\s+/g, '');
      say('Checking Ethereum\u2026');
      return verify(wallet, vault).then(function (r) {
        if (r.ok) {
          try { localStorage.setItem(KEY + '_vault', vault || ''); } catch (e) {}
          setOk(wallet);
        } else {
          statusEl.innerHTML = '<b style="color:#111">No access found.</b><br>' + r.lines.join('<br>');
        }
      });
    }).catch(function (e) { say(e && e.code === 4001 ? 'Connection cancelled.' : 'Something went wrong: ' + (e && e.message || e)); });
  }

  function init() {
    // Only show the widget if this store has anything NFT-locked on the page, or the shopper already has access
    restore();
    build();
    if (!document.querySelector('.nft-locked') && !document.querySelector('[data-nft-404]') && !root.classList.contains('nft-ok')) {
      // keep the small button available on every page (it is the only entry point for collectors)
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
